export enum EventTypes {
  ConfigLoaded,
  ConfigLoadingFailed,
  CheckSessionReceived,
  UserDataChanged,
  NewAuthorizationResult,
  TokenExpired,
  IdTokenExpired,
}
